var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconGridView = function SvgIconGridView(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 87 87",
    id: "vector",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M 5 0 L 33 0 C 34.326 0 35.598 0.527 36.536 1.464 C 37.473 2.402 38 3.674 38 5 L 38 24 C 38 25.326 37.473 26.598 36.536 27.536 C 35.598 28.473 34.326 29 33 29 L 5 29 C 3.674 29 2.402 28.473 1.464 27.536 C 0.527 26.598 0 25.326 0 24 L 0 5 C 0 3.674 0.527 2.402 1.464 1.464 C 2.402 0.527 3.674 0 5 0 Z",
    fill: "#d8d8d8",
    stroke: "#00000000",
    strokeWidth: 1,
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path_1",
    d: "M 4 33 L 28 33 C 28.53 33 29.039 33.211 29.414 33.586 C 29.789 33.961 30 34.47 30 35 L 30 35 C 30 35.53 29.789 36.039 29.414 36.414 C 29.039 36.789 28.53 37 28 37 L 4 37 C 3.47 37 2.961 36.789 2.586 36.414 C 2.211 36.039 2 35.53 2 35 L 2 35 C 2 34.47 2.211 33.961 2.586 33.586 C 2.961 33.211 3.47 33 4 33 Z",
    fill: "#d8d8d8",
    stroke: "#00000000",
    strokeWidth: 1,
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path_2",
    d: "M 54 0 L 82 0 C 83.326 0 84.598 0.527 85.536 1.464 C 86.473 2.402 87 3.674 87 5 L 87 24 C 87 25.326 86.473 26.598 85.536 27.536 C 84.598 28.473 83.326 29 82 29 L 54 29 C 52.674 29 51.402 28.473 50.464 27.536 C 49.527 26.598 49 25.326 49 24 L 49 5 C 49 3.674 49.527 2.402 50.464 1.464 C 51.402 0.527 52.674 0 54 0 Z",
    fill: "#d8d8d8",
    stroke: "#00000000",
    strokeWidth: 1,
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path_3",
    d: "M 53 33 L 77 33 C 77.53 33 78.039 33.211 78.414 33.586 C 78.789 33.961 79 34.47 79 35 L 79 35 C 79 35.53 78.789 36.039 78.414 36.414 C 78.039 36.789 77.53 37 77 37 L 53 37 C 52.47 37 51.961 36.789 51.586 36.414 C 51.211 36.039 51 35.53 51 35 L 51 35 C 51 34.47 51.211 33.961 51.586 33.586 C 51.961 33.211 52.47 33 53 33 Z",
    fill: "#d8d8d8",
    stroke: "#00000000",
    strokeWidth: 1,
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path_4",
    d: "M 54 50 L 82 50 C 83.326 50 84.598 50.527 85.536 51.464 C 86.473 52.402 87 53.674 87 55 L 87 74 C 87 75.326 86.473 76.598 85.536 77.536 C 84.598 78.473 83.326 79 82 79 L 54 79 C 52.674 79 51.402 78.473 50.464 77.536 C 49.527 76.598 49 75.326 49 74 L 49 55 C 49 53.674 49.527 52.402 50.464 51.464 C 51.402 50.527 52.674 50 54 50 Z",
    fill: "#d8d8d8",
    stroke: "#00000000",
    strokeWidth: 1,
    fillRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "path_5",
    d: "M 53 83 L 77 83 C 77.53 83 78.039 83.211 78.414 83.586 C 78.789 83.961 79 84.47 79 85 L 79 85 C 79 85.53 78.789 86.039 78.414 86.414 C 78.039 86.789 77.53 87 77 87 L 53 87 C 52.47 87 51.961 86.789 51.586 86.414 C 51.211 86.039 51 85.53 51 85 L 51 85 C 51 84.47 51.211 83.961 51.586 83.586 C 51.961 83.211 52.47 83 53 83 Z",
    fill: "#d8d8d8",
    stroke: "#00000000",
    strokeWidth: 1,
    fillRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "path_6",
    d: "M 5 50 L 33 50 C 34.326 50 35.598 50.527 36.536 51.464 C 37.473 52.402 38 53.674 38 55 L 38 74 C 38 75.326 37.473 76.598 36.536 77.536 C 35.598 78.473 34.326 79 33 79 L 5 79 C 3.674 79 2.402 78.473 1.464 77.536 C 0.527 76.598 0 75.326 0 74 L 0 55 C 0 53.674 0.527 52.402 1.464 51.464 C 2.402 50.527 3.674 50 5 50 Z",
    fill: "#d8d8d8",
    stroke: "#00000000",
    strokeWidth: 1,
    fillRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "path_7",
    d: "M 4 83 L 28 83 C 28.53 83 29.039 83.211 29.414 83.586 C 29.789 83.961 30 84.47 30 85 L 30 85 C 30 85.53 29.789 86.039 29.414 86.414 C 29.039 86.789 28.53 87 28 87 L 4 87 C 3.47 87 2.961 86.789 2.586 86.414 C 2.211 86.039 2 85.53 2 85 L 2 85 C 2 84.47 2.211 83.961 2.586 83.586 C 2.961 83.211 3.47 83 4 83 Z",
    fill: "#d8d8d8",
    stroke: "#00000000",
    strokeWidth: 1,
    fillRule: "evenodd"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconGridView, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_grid_view.a48443d9.svg";
export { ForwardRef as ReactComponent };